<template>
    <div class="w-100 d-flex justify-content-end mb-4">
        <slot></slot>

        <component v-for="item in toolbarItems" :key="item.type" :is="item.type" :settings="item.settings" :data-source="dataSource"></component>
    </div>
</template>

<script>
import ExcelExport from "./Items/ExcelExport.vue";
import ColumnPicker from "./Items/ColumnPicker.vue";

/**
 * toolbarSettings: {
 *  ?items: [
 *    {
 *      ?type: enum("ExcelExport", "ColumnPicker"),
 *      ?settings: Object, see component for details
 *    }
 *  ]
 * }
 */
export default {
    inject: {
        nsDatatableContext: {
            default: null,
        },
    },
    provide() {
        const vm = this;

        return {
            nsToolbarContext: {
                emitEvent(eventName, data) {
                    vm.$emit("emit-event", { eventName, data });
                },
            },
        };
    },
    props: {
        toolbarSettings: {
            type: Object,
            default: () => {
                return {};
            },
        },
        dataSource: {
            type: Array,
            required: true,
        },
    },
    methods: {
        getTable() {
            if (this.nsDatatableContext && typeof this.nsDatatableContext.getTable === "function") {
                return this.nsDatatableContext.getTable();
            }

            return this.$parent.getTable();
        },
        getDataSource(params = {}) {
            if (this.nsDatatableContext && typeof this.nsDatatableContext.getDataSource === "function") {
                return this.nsDatatableContext.getDataSource(params);
            }

            return this.$parent.getDataSource(params);
        },
    },
    computed: {
        toolbarItems() {
            if (Array.isArray(this.toolbarSettings.items)) {
                return this.toolbarSettings.items;
            }

            return [];
        },
    },
    components: {
        ExcelExport,
        ColumnPicker,
    },
};
</script>
